module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAaCAYAAAC+aNwHAAAA7ElEQVR4AczUPw6CMBQGcHAg3sArsJi4eAAGB29CwokIF3FwcHdwceAIHqJ//N7Ql9SW0lcWCS8l0O+XtK9hV228/ggYx/GJek3TdJCsipdgrd0jeDLGPCQIA1rrC4AZ1UoQBoZh+CilOgAihAEEqxLEA0qQAJAiUUCCLAK5SBKIIWj3nd67WgVoYtM0lkaquq4Vja5WATqVdLAQaFEzzsoVI99JIBLu6KxwGg+LQE4Y+SoK5IajgCQcANKwB5SEPQCtuuGFa1Ww2/gWvXkT8UdSqDf6nB0mkYG+78+o42+faVKqGEhNSn3bDHwBAAD//+ws9zQAAAAGSURBVAMA41rcNWi9YO4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_go.png
// module id = a6IK
// module chunks = 1